import { Message, MessageIn } from "../../services/Api/swagger";
import { MessagesFormData } from "./MessagesForm";

export const transformMessagesFormDataToMessageIn = (
  values: MessagesFormData
): MessageIn => {
  const message: MessageIn = {
    titre: values.titre,
    contenu: values.contenu,
    dateDebut: values.dateDebut,
    dateFin: values.dateFin,
  };
  return message;
};
export const transformMessagesFormDataToMessage = (
  id: number,
  values: MessagesFormData
): Message => {
  const message: Message = {
    id: id,
    titre: values.titre,
    contenu: values.contenu,
    dateDebut: values.dateDebut,
    dateFin: values.dateFin,
  };
  return message;
};
